import { useContext } from "react";

import { BTIconInfoCircleFilled } from "commonComponents/btWrappers/BTIcon";
import { BTPopover } from "commonComponents/btWrappers/BTPopover/BTPopover";

import { VendorTypes } from "entity/vendor/common/vendor.types";
import { getVendorName } from "entity/vendor/common/vendor.utility";
import VendorLabel from "entity/vendor/VendorLabel/VendorProductLabel";
import { VendorProductInfoContext } from "entity/vendor/VendorProductInfoContainer/VendorProductInfoContainer";
import VendorProductPopover from "entity/vendor/VendorProductPopover/VendorProductPopover";

import "./VendorProductLabel.less";

interface IVendorProductLabelProps {
    vendorType: VendorTypes;
    vendorProductId: number;
    showIcon?: boolean;
    isDiscontinued?: boolean;
    showPopover?: boolean;
}

const VendorProductLabel: React.FC<IVendorProductLabelProps> = ({
    showIcon = false,
    isDiscontinued = false,
    showPopover = false,
    ...props
}) => {
    const vendorProductInfoContext = useContext(VendorProductInfoContext);

    if (props.vendorType === VendorTypes.Unknown) {
        return null;
    }

    const handleVisibleChange = async (visible: boolean) => {
        if (visible) {
            await vendorProductInfoContext.onVendorProductInfoRequest();
        }
    };

    const type = isDiscontinued ? "error" : "info";
    const innerContent = (
        <span className="VendorProductLabel">
            <VendorLabel>{getVendorName(props.vendorType)} Product</VendorLabel>{" "}
            {showIcon && <BTIconInfoCircleFilled className="InfoIcon" type={type} />}
        </span>
    );

    if (showPopover) {
        return (
            <div>
                <BTPopover
                    overlayClassName="VendorProductLabel VendorProductPopover"
                    placement="right"
                    content={
                        <VendorProductPopover
                            vendorInventory={vendorProductInfoContext.vendorProductInventory?.inventory.get(
                                String(props.vendorProductId),
                            )}
                        />
                    }
                    onVisibleChange={handleVisibleChange}
                    data-testid="vendorProductPopover"
                >
                    {innerContent}
                </BTPopover>
            </div>
        );
    } else {
        return <div>{innerContent}</div>;
    }
};

export default VendorProductLabel;
